import * as countryCodes from "country-codes-list";

export const countries = countryCodes
  .customArray({
    label: "{countryNameEn}",
    value: "{countryNameEn}-{countryCode}",
  })
  .map(({ value, label }) => ({ label, value: value.toLowerCase() }));
